// extracted by mini-css-extract-plugin
export var clamp = "QuaddieOutcome-module--clamp--a69ea";
export var isVoid = "QuaddieOutcome-module--isVoid--0de47";
export var outcome = "QuaddieOutcome-module--outcome--ad6a9";
export var raceIcon = "QuaddieOutcome-module--raceIcon--3a3a7";
export var runners = "QuaddieOutcome-module--runners--26de7";
export var won = "QuaddieOutcome-module--won--666af";